import { render } from "./RotZ.vue?vue&type=template&id=6d234c10"
import script from "./RotZ.vue?vue&type=script&lang=js"
export * from "./RotZ.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__